import { FormContainer } from '@/components/FormContainer'
import { BusinessInfoEditor } from '@/features/tax-profile/business-profiles/components/BusinessInfoEditor'
import type { BusinessProfileEditorViewModel } from '@/features/tax-profile/business-profiles/BusinessProfileEditorViewModel'
import { ContactInfoEditor } from '@/features/tax-profile/components/ContactInfoEditor'
import { FormFieldSet, FormFieldSetLegend } from '@/components/Form'
import { observer } from 'mobx-react-lite'
import { IsSkeletonContext } from '@/components/Skeleton'

export interface BusinessProfileEditorProps {
  formId?: string
  isDisabled?: boolean
  isSkeleton?: boolean
  vm: BusinessProfileEditorViewModel
}

/**
 * Form for editing a business profile.
 */
export const BusinessProfileEditor = observer(function BusinessProfileEditor({
  formId,
  isDisabled,
  isSkeleton,
  vm,
}: BusinessProfileEditorProps) {
  const testId = 'business-profile-editor'
  return (
    <IsSkeletonContext value={isSkeleton}>
      <FormContainer
        id={formId}
        onSubmit={vm.save}
        disabled={isDisabled || vm.save.pending}
        testId={testId}
      >
        <FormFieldSet>
          <FormFieldSetLegend>Business information</FormFieldSetLegend>
          <BusinessInfoEditor vm={vm.businessInfoVm} testId={testId} />
        </FormFieldSet>

        <FormFieldSet>
          <FormFieldSetLegend>Contact information</FormFieldSetLegend>
          <ContactInfoEditor
            vm={vm.contactInfoVm}
            testId={`${testId}-contact-info`}
          />
        </FormFieldSet>
      </FormContainer>
    </IsSkeletonContext>
  )
})
